import Select from 'react-select';

export const STATUS_OPTIONS = ['pending', 'reviewed', 'accepted', 'rejected'].map((s) => ({
  value: s,
  label: s.charAt(0).toUpperCase() + s.slice(1),
}));

export const STAR_OPTIONS = [1, 2, 3, 4, 5].map((n) => ({
  value: String(n),
  label: `${n} ★`,
}));

/**
 * Generic reusable select built on react-select.
 * Used for status filter/table column and star-rating filter.
 *
 * Props:
 *   options      — array of { value, label } (required)
 *   value        — current value string or '' for none
 *   onChange     — (value: string) => void
 *   label        — label text shown above (default 'Select')
 *   showLabel    — render the label (default true)
 *   isClearable  — allow clearing (default false)
 *   isCompact    — smaller height/font for inline table use (default false)
 *   placeholder  — placeholder text
 */
function StatusSelect({
  options = STATUS_OPTIONS,
  value = '',
  onChange,
  label = 'Select',
  showLabel = true,
  isClearable = false,
  isCompact = false,
  placeholder = 'Select…',
}) {
  const selected = value ? options.find((o) => o.value === value) ?? null : null;

  return (
    <div style={isCompact ? { minWidth: 148 } : {}}>
      {showLabel && <label className="label d-block">{label}</label>}
      <Select
        options={options}
        value={selected}
        onChange={(opt) => onChange(opt ? opt.value : '')}
        isClearable={isClearable}
        placeholder={placeholder}
        /* Render menu in <body> — escapes table overflow + always opens downward */
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          control: (base, state) => ({
            ...base,
            borderColor: state.isFocused ? '#c87dd4' : '#e9baf0',
            boxShadow: '0 0.8rem 1.2rem rgba(20, 102, 204, 0.14)',
            minHeight: isCompact ? 34 : 38,
            fontSize: isCompact ? 13 : 14,
            cursor: 'pointer',
          }),
          valueContainer: (base) => ({
            ...base,
            padding: isCompact ? '0 6px' : '2px 8px',
          }),
          dropdownIndicator: (base) => ({
            ...base,
            padding: isCompact ? '4px' : '8px',
            color: '#c87dd4',
          }),
          /* Visible separator between the selected value and the dropdown chevron */
          indicatorSeparator: (base) => ({
            ...base,
            backgroundColor: '#e9baf0',
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          option: (base, state) => ({
            ...base,
            fontSize: 13,
            backgroundColor: state.isSelected ? '#e9baf0' : state.isFocused ? '#f9edfb' : 'white',
            color: '#333',
          }),
        }}
      />
    </div>
  );
}

export default StatusSelect;
